export default {
    title: '查詢結果'
}
